import axios from 'axios';
import { getTimeZone } from '@/lib/util/zonedTime';

const instance = axios.create();

// Defaults
instance.defaults.baseURL = process.env.NEXT_PUBLIC_SWAG_API_URL;
instance.defaults.withCredentials = true;
instance.defaults.headers.common[ 'x-local-tz' ] = getTimeZone();

export default instance;

export const jsonApiHeaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'x-local-tz': getTimeZone()
};
